import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TransactionService} from '../../transaction/transaction.service';
import {AppointmentService} from '../../appointment/appointment.service';
import {DatePipe} from '@angular/common';
import {PhysicianService} from '../service/physician.service';
import {PatientService} from '../../patient/service/patient.service';
import {PhysicianTransactionComponent} from '../physician-transaction/physician-transaction.component';
import {MatDialog} from '@angular/material';
import {AddCommissionComponent} from './add-commission/add-commission.component';
import {CommissionService} from './commission.service';

@Component({
  selector: 'app-commission',
  templateUrl: './commission.component.html',
  styleUrls: ['./commission.component.css']
})
export class CommissionComponent implements OnInit {

    viewPhysicianCommisionForm: FormGroup;
    fromDate = new Date();
    toDate = new Date();
    keyword = 'physicianName';
    loadingPhysician = false;
    loading = false;
    physicianList = [];
    physicianCommissionList = [];
    physicianName:string='';
    addButtomDisable: boolean = true;


    constructor(private _formBuilder: FormBuilder,
              private commissionService:CommissionService,
                private datepipe: DatePipe,
                public dialog: MatDialog,
                private physicianService:PhysicianService) {

      this.viewPhysicianCommisionForm = this. _formBuilder.group({
          filterChoose: ['', Validators.required],
          searchPhyId: [''],
          searchUserId: [''],
          searchPatientId: [''],
          searchAppointmentId: [''],
          fromDate: [this.fromDate , Validators.required],
          toDate: [this.toDate, Validators.required]
      });
  }



  ngOnInit() {
  }


  getAllPhysician(term) {
        this.loadingPhysician = true;
        this.physicianList = [];
        this.physicianService.getAllPhysicians(0,'',999, term)
            .subscribe(data => {
                const response: any = data.json();
                this.physicianList = response.physicians;
                this.loadingPhysician = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    getPhysicianCommission(id) {
        this.loadingPhysician = true;
        this.physicianCommissionList = [];
        this.commissionService.getPhysicianCommission(id)
            .subscribe(data => {
                const response: any = data.json();
                this.physicianCommissionList = response;
                this.loadingPhysician = false;
            }, (error) => {
                this.loading = false;
                // this.toastr.error('', 'Please try again');
            });
    }

    selectEvent(item) {
        console.log(item);
        this.viewPhysicianCommisionForm.patchValue({searchUserId:item.userId});
        this.addButtomDisable = false;
        this.physicianName = item.physicianName;
        this.getPhysicianCommission(item.userId);
        // get all commision for physician
    }

    addPhysicianCommissionFees() {
        const dialogRef = this.dialog.open(AddCommissionComponent, {
            data: {id:this.viewPhysicianCommisionForm.get('searchUserId'), name:
               this.physicianName},
            height: '600px',
            width: '1000px',
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            this.getPhysicianCommission(this.viewPhysicianCommisionForm.get('searchUserId').value);
        });
    }

    editPhysicianCommissionFee() {

    }

    cleared(){
        this.viewPhysicianCommisionForm.reset();
        this.addButtomDisable = true;
        this.physicianName = "";
        this.physicianCommissionList=[]
    }



}
